<template>
	<div class="text-center mt-sm-5">
		Please select a song from the list or <router-link to="/songs/add">add a new one</router-link>.
	</div>

</template>

<script>
	export default {
		name: "Placeholder"
	}
</script>

<style scoped>

</style>
